"use strict";
/*
 * Copyright (C) 2017-2019 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks if the given definition implements the [[ValueDefinition]] interface.
 */
function isValueDefinition(def) {
    const valueDef = def;
    return (typeof valueDef === "object" &&
        valueDef !== null &&
        typeof valueDef.type === "string" &&
        valueDef.value !== undefined);
}
exports.isValueDefinition = isValueDefinition;
function isSelectorDefinition(def) {
    const valueDef = def;
    return (typeof valueDef === "object" &&
        valueDef !== null &&
        valueDef.type === "selector" &&
        (typeof valueDef.value === "string" || Array.isArray(valueDef.value)));
}
exports.isSelectorDefinition = isSelectorDefinition;
/**
 * Checks if the given value is a reference to a definition.
 *
 * @param value The value of a technique property.
 */
function isJsonExprReference(value) {
    return (Array.isArray(value) &&
        value.length === 2 &&
        value[0] === "ref" &&
        typeof value[1] === "string");
}
exports.isJsonExprReference = isJsonExprReference;
function isActualSelectorDefinition(def) {
    const styleDef = def;
    return (typeof styleDef === "object" &&
        styleDef !== null &&
        !Array.isArray(styleDef) &&
        typeof styleDef.technique === "string");
}
exports.isActualSelectorDefinition = isActualSelectorDefinition;
